const isOtherDomain = function (url) {
  return (url.startsWith('http://') || url.startsWith('https://')) && !url.includes('kamigame.jp') && !url.includes('gamevillage.net');
};

module.exports = function aAddTargetBlank(md) {
  const defaultRender = md.renderer.rules.link_open || function (tokens, idx, options, env, self) {
    return self.renderToken(tokens, idx, options);
  };

  md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
    const token = tokens[idx];
    const hrefIndex = token.attrIndex('href');
    if (hrefIndex < 0) {
      return defaultRender(tokens, idx, options, env, self);
    }

    const hrefValue = token.attrs[hrefIndex][1];
    if (isOtherDomain(hrefValue)) {
      const aIndex = token.attrIndex('target');
      if (aIndex < 0) {
        tokens[idx].attrPush(['target', '_blank']);
      } else {
        tokens[idx].attrs[aIndex][1] = '_blank';
      }
    }
    return defaultRender(tokens, idx, options, env, self);
  };
};
